// extracted by mini-css-extract-plugin
export default {"container":"CompanySelectionPage_container__Sm6l0","content":"CompanySelectionPage_content__OhhA1"};